// React
import React from "react";

// Internal
import {getDataTestId} from "../functions/data-test-ids";
import {FormInput} from "./form-input";

// CSS
import "./forms.css";

function FormSkeleton(props) {
    const dataTestId = getDataTestId(props.DataTestId, "skeleton");
    return (
        <FormInput Label={props.Label} DataTestId={dataTestId}>
            <div className="eone-ui-skeleton"/>
        </FormInput>
    );
}

export {FormSkeleton};